import { render, staticRenderFns } from "./ItemLicence.vue?vue&type=template&id=09c74bd0&"
import script from "./ItemLicence.vue?vue&type=script&lang=js&"
export * from "./ItemLicence.vue?vue&type=script&lang=js&"
import style0 from "./ItemLicence.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports